import {useContext, useEffect, useState} from "react";
import EditQRCodeContext from "./EditQRCodeContext";
import {useForm, UseFormReturnType} from "@mantine/form";
import EditQRCodePayload from "../../../api/qr-code/EditQRCodePayload";
import {Button, Stack, TextInput} from "@mantine/core";
import QRCodeApi from "../../../api/qr-code/QRCodeApi";
import {useNavigate} from "react-router-dom";
import QRCodeContext from "../../../contexts/qr-code/QRCodeContext";

type _FormType = Pick<EditQRCodePayload, "websiteUrl" | "name">;

export const WebsiteEditForm = () => {
    const nav = useNavigate();
    const [isLoading, setLoading] = useState<boolean>(false);
    const { reload } = useContext(QRCodeContext);
    const { qrCode } = useContext(EditQRCodeContext);

    const form: UseFormReturnType<_FormType> = useForm<_FormType>({
        initialValues: {
            websiteUrl: "",
            name: ""
        }
    });
    const onSubmit = (values: _FormType) => {
        if (!qrCode) {
            throw new Error("QRCode is not defined");
        }
        setLoading(true);

        QRCodeApi.editById(qrCode.id, values)
            .then(() => reload())
            .then(() => nav(-1))
            .finally(() => setLoading(false));
    }
    useEffect(() => {
        form.setValues({
            websiteUrl: qrCode?.websiteUrl ?? "",
            name: qrCode?.name ?? ""
        });
        // eslint-disable-next-line
    }, [qrCode]);

    return (
        <form onSubmit={form.onSubmit(onSubmit)}>
            <Stack>
                <TextInput
                    required
                    placeholder="Nazwa kodu QR"
                    {...form.getInputProps('name')}
                />

                <TextInput
                    required
                    placeholder="Adres URL"
                    {...form.getInputProps('websiteUrl')}
                />

                <Button loading={isLoading} type="submit">
                    Zapisz
                </Button>
            </Stack>
        </form>
    )
}